import React from 'react'
import Styles from '../../Css/Hotspot/Hotspot.module.css'

function HotSpotDeleteModal(props) {


    const handleDeleteChoice = (choice)=>{
        props.handleHotSpotLiDeleteChoice(choice);
    }



    return (
        <div className={[Styles['custom-model']]}>
            <img 
                src={`${process.env.REACT_APP_CLOUD_STORAGE_PREFIX}/spyne-website/static/app-dashboard/doubtHotSpot.png`} 
                alt="doubt" 
            />

            <div>
                <h4>
                    Are you sure you want to delete '{ (props.showDelete && props.showDelete.hotSpotTitleToDelete) ? (props.showDelete.hotSpotTitleToDelete) : ('This Hotspot')}' from all frames?
                </h4>
            </div>
            

            <div className={[Styles['custom-model-choice-btn']]}>
                <button onClick={e=>handleDeleteChoice(true)}>
                    Yes, Delete
                </button>
                <button onClick={e=>handleDeleteChoice(false)}>
                    No, Cancel
                </button>
            </div>
            
        </div>
    )
}


export default HotSpotDeleteModal;